import AccettazioneSsn from "../";

const routes = [
    { name: "Elenco Accettazione Ssn", path: "/accettazionessn", component: AccettazioneSsn.AccettazioneSsnListPage, meta: { title: "Elenco Accettazioni" } },
    { name: "Accettazione Ssn", path: "/accettazionessn/:id", component: AccettazioneSsn.AccettazioneSsnEditViewPage, meta: { title: "Crea/Modifica Accettazione" } },
    { name: "Accettazione Ssn Scheda Paziente", path: "/accettazionessn/schedapaziente/:id", component: AccettazioneSsn.AccettazioneSsnSchedaPazientePage, meta: { title: "Scheda Paziente" } },
];

export default routes;
